import React, { useRef, useEffect } from 'react';
import './MainContent.css'; 
import InputBar from './components/InputBar';
import ChatMessage from '../Chat/ChatMessage'; 
import { HIDDEN_MESSAGE_PREFIX } from '../AppLayout/AppLayout';

const MainContent = ({ messages , onSendMessage, onFileUpload, onDownloadFile, messageRefs ,isTyping}) => { // Default array vuoto
    const chatHistoryRef = useRef(null);

    // PROTEZIONE: Se messages è undefined, usa un array vuoto
    const safeMessages = messages || [];
    const chatStarted = safeMessages.length > 0 || isTyping; 

    useEffect(() => {
        if (chatHistoryRef.current) {
            chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
        }
    }, [safeMessages,isTyping]);

    const wrapperClass = chatStarted 
        ? "main-content-wrapper chat-active" 
        : "main-content-wrapper initial-center";

    return (
        <div className="app-main-content">
            <div className={wrapperClass}>
                
                {/* Stato Iniziale: Centratura */}
                {!chatStarted && (
                    <div className="center-content">
                        <h1 className="greeting-message">Tell me what you need</h1>
                        <InputBar onSend={onSendMessage} onFileUpload={onFileUpload} />
                    </div>
                )}

                {/* Stato Attivo: Layout Chat */}
                {chatStarted && (
                    <>
                        <div className="chat-history" ref={chatHistoryRef}>
                            {safeMessages.map((msg, index) => {
                                const isHiddenMessage = msg.text.includes(HIDDEN_MESSAGE_PREFIX);
                                
                                if (isHiddenMessage) return null; //INVISIBILE, non viene stampato a video  

                                return (
                                    <div
                                        key={msg.id || index}
                                        ref={el => {
                                            if (messageRefs && msg.id) {
                                                messageRefs.current[msg.id] = el;
                                            }
                                        }}
                                    >
                                        <ChatMessage message={msg} isUser={msg.isUser} onDownloadFile={onDownloadFile} />
                                    </div>
                                );
                            })}

                            {isTyping && (
                                <div className="chord-thinking-wrapper">
                                    <span className="typing-dots">
                                        <span>.</span><span>.</span><span>.</span>
                                    </span>
                                    Chord is thinking
                                </div>
                            )}
                        </div>
                        <InputBar onSend={onSendMessage} onFileUpload={onFileUpload} />
                    </>
                )}
            </div>
        </div>
    );
};

export default MainContent;